import { buildRecommendations, } from '../../../../controllers/commerce/recommendations/headless-recommendations.js';
import { recommendationInternalOptionKey } from '../../types/controller-constants.js';
import { createControllerWithKind, Kind } from '../../types/kind.js';
/**
 * Defines a `Recommendations` controller instance.
 * @group Definers
 *
 * @param props - The configurable `Recommendations` properties.
 * @returns The `Recommendations` controller definition.
 * */
export function defineRecommendations(props) {
    return {
        recommendation: true,
        [recommendationInternalOptionKey]: {
            ...props.options,
        },
        buildWithProps: (engine, options) => {
            const staticOptions = props.options;
            const controller = buildRecommendations(engine, {
                options: { ...staticOptions, ...options },
            });
            return createControllerWithKind(controller, Kind.Recommendations);
        },
    };
}
